import { render, staticRenderFns } from "./ListRewardMonthPhoneProgram.vue?vue&type=template&id=881b2c58&scoped=true"
import script from "./ListRewardMonthPhoneProgram.vue?vue&type=script&lang=js"
export * from "./ListRewardMonthPhoneProgram.vue?vue&type=script&lang=js"
import style0 from "./ListRewardMonthPhoneProgram.vue?vue&type=style&index=0&id=881b2c58&prod&scoped=true&lang=css"
import style1 from "./ListRewardMonthPhoneProgram.vue?vue&type=style&index=1&id=881b2c58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881b2c58",
  null
  
)

export default component.exports